module.exports = __webpack_public_path__ + "static/media/dashboard-books.c038f9e8.jpg";